export const REGISTRATION_INITIAL_STATE = {
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
    user_type: '',
    password: ''
}